import HTMLReactParser from "html-react-parser";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { ChatPost } from "../../../lib/types";

import avatar from "../../../assets/images/avatar-temp.png";
import CheckBox from "../../Common/CheckBox";
import { formatToPostDate } from "../../../lib/commonFunctions";
import { openContentPopup } from "../../../store/actions";
import GovernorateInfoLink from "../../Common/GovernorateInfoLink";
import AllianceInfoLink from "../../Common/AllianceInfoLink";

interface IProps {
  post: ChatPost;
  toDelete: boolean;
  toggleToDelete: () => void;
  addReactMessage: (message: string) => void;
}

const mapDispatchToProps = (dispatch: any) => ({
  openContentPopupDispatch: (options: any) => dispatch(openContentPopup(options))
});

const connector = connect(null, mapDispatchToProps);

const ChatPostComponent = ({
  post,
  toDelete,
  toggleToDelete,
  addReactMessage,
  openContentPopupDispatch
}: IProps & ConnectedProps<typeof connector>) => (
  <div className={`comment ${post.new ? "active" : ""} ${post.deleted ? "deleted" : ""}`}>
    <header className="comment-header clearfix">
        <span className="user">
            <img src={avatar} alt="Dragon avatar" className="avatar"/>
            <span className={"comment-info"}>
            <strong className="gubernate">
              {post.governy.emperor && <i className={`icon icon-imperator ${post.governy.race.name}`}/>}
              {post.governy.commander && <i className={`icon icon-vojevudce ${post.governy.race.name}`}/>}
              <GovernorateInfoLink
                govId={post.governy.id}
                name={post.governy.name}
                raceName={post.governy.race.name}
              />
            </strong>
            <span className="coalition grey">
              {post.governy.alliance
                ? <>
                  &nbsp;
                  (<AllianceInfoLink
                    name={post.governy.alliance.name}
                    allianceId={post.governy.alliance.id}
                  />)
                </>
                : <>&nbsp;(Non-alliance)</>}
            </span>
            <small>&nbsp;({formatToPostDate(new Date(post.postDate.timestamp * 1000))})</small>
            <strong>
              &nbsp;<a href="#account-info-{{ post.governy.playerId }}" className={"grey"}>{post.governy.player.name}</a>
            </strong>
            </span>
        </span>
      <span className="pull-right actions hidden-xs">
        {post.governy.lastAction
        && <small>[online {post.governy.lastAction}]</small>}
      </span>
    </header>
    <div className="comment-body clearfix">
      <p>{HTMLReactParser(post.content)}</p>
      <div className="row">
        <div className="col-sm-5 col-sm-push-3 col-lg-6 achievements">
          {/* {post.governy.goldStatus && <i className="icon icon-popularita gold"/>} */}
        </div>
        <div className="col-xs-6 col-sm-3 col-sm-pull-5 col-lg-pull-6 actions admin-actions">
          {post.canBeDeleted && <CheckBox checked={toDelete} toggle={toggleToDelete} />}
          <a
            className="icon icon-standalone icon-posta item"
            onClick={() => openContentPopupDispatch({
              name: "Mail",
              title: "Mail",
              icon: "posta",
              presetRecipient: post.governy.name
            })}
          />
          <a
            className="link grey"
            onClick={() => addReactMessage(
              // @ts-ignore
              `RE: ${post.governy.name} (${post.governy.alliance ? post.governy.alliance.name : "Non-alliance"}) (${formatToPostDate(new Date(post.postDate.timestamp * 1000))}) ${post.governy.player.name}:`
            )}
          >react</a>
        </div>
      </div>
    </div>
  </div>
)

export default connector(ChatPostComponent);
